module.exports = __webpack_public_path__ + "img/E-Wallet-amico.75f49142.svg";